import {Injectable, ViewContainerRef} from '@angular/core';
@Injectable()
export class ViewService {
    private _viewContainerRef: ViewContainerRef;

    get viewContainerRef(): ViewContainerRef {
        return this._viewContainerRef;
    }
    set viewContainerRef(value: ViewContainerRef) {
        this._viewContainerRef = value;
    }
}